import { render, staticRenderFns } from "./question-groups.vue?vue&type=template&id=949628a4&scoped=true&"
import script from "./question-groups.vue?vue&type=script&lang=js&"
export * from "./question-groups.vue?vue&type=script&lang=js&"
import style0 from "./question-groups.vue?vue&type=style&index=0&id=949628a4&prod&lang=css&"
import style1 from "./question-groups.vue?vue&type=style&index=1&id=949628a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949628a4",
  null
  
)

export default component.exports